<template>
<layout title="WCIA Manifests" disable_scroll>
  <template v-slot:actions>
    <CreateFromManifest ref="create_order" :preloaded_manifest="loaded_manifest">
      <template v-slot:activator="{on}">
        <v-btn v-on="on">Create Order</v-btn>
      </template>
    </CreateFromManifest>
  </template>
<!--  WORK IN PROGRESS-->
<!--  <IntegratorParser>-->
<!--    <template v-slot:activator="{on}">-->
<!--      <v-btn v-on="on">WCIA Manifest Parse</v-btn>-->
<!--    </template>-->
<!--  </IntegratorParser>-->
  <ParseManifestJson></ParseManifestJson>
<!--  {{ manifests}}-->
  <v-card flat :disabled="loading" :loading="loading">
    <v-card-text class="black--text">
      <v-row>
        <v-col cols="2" v-for="type in legalTypeCounts" :key="type.type">
          <v-list-item-content>
            <v-list-item-title class="text-center font-weight-bold">{{type.type}}</v-list-item-title>
            <v-list-item-subtitle class="text-center">{{type.count}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-col>
        <v-col cols="2" v-for="date in dateCounts" :key="date.type">
          <v-list-item-content>
            <v-list-item-title class="text-center font-weight-bold">{{date.date}} Samples</v-list-item-title>
            <v-list-item-subtitle class="text-center">{{date.count}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-col>
      </v-row>
    </v-card-text>
    <v-simple-table>
      <thead>
      <tr>
        <th></th>
        <th style="width:15%"><v-text-field v-model="filters.from_license_name" label="Customer" hide-details></v-text-field></th>
        <th style="width:15%"><v-text-field v-model="filters.transfer_id" label="Manifest ID" hide-details></v-text-field></th>
        <th style="width:15%"><v-text-field v-model="filters.license" label="License" hide-details></v-text-field></th>
        <th>Number of samples</th>
        <th>Transferred At <v-btn @click="sortTransferredAt" x-small>sort</v-btn></th>
        <td>Remove</td>
      </tr>
      </thead>
      <tbody>
      <tr v-if="filteredManifests.length === 0">
        <td colspan="7" class="text-center">No data</td>
      </tr>
      <tr v-for="manifest in filteredManifests" :key="manifest.transfer_id">
        <td style="width:1%">
          <v-btn @click="createOrder(manifest)">Create Order</v-btn>
        </td>
        <td>{{ manifest.from_license_name }}</td>
        <td>{{ manifest.transfer_id }}</td>
        <td>{{ manifest.from_license_number }}</td>
        <td>{{ manifest.inventory_transfer_items.length }}</td>
        <td>{{ $moment(manifest.transferred_at).format('YYYY-MM-DD h:mmA')}}</td>
        <td>
          <Confirm @confirmed="deleteManifest(manifest.transfer_id)">
            <template v-slot:activator="{on}">
              <v-btn v-on="on" color="error">Delete</v-btn>
            </template>
          </Confirm>
        </td>
      </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</layout>
</template>

<script>
export default {
  name: "index",
  components: {
    IntegratorParser: () => import("@/views/Tracking/components/IntegratorParser"),
    ParseManifestJson: () => import("@/views/Manifests/components/ParseManifestJson"),
    CreateFromManifest: () => import("@/views/orders/components/Manifest/CreateFromManifest")
  },
  props: {},
  data: () => ({
    listener: null,
    manifests: [],
    loaded_manifest: null,
    loading: false,
    filters: {
      license: null,
      transfer_id: null,
      from_license_name: null,
    }
  }),
  computed: {
    filteredManifests(){
      return this.manifests.filter((manifest) => {
        let pass = true;
        let passLicense = true;
        let passTransferId = true;
        let passFromLicenseName = true;
        if(this.filters.license) passLicense = manifest.from_license_number && manifest.from_license_number.toLowerCase().includes(this.filters.license.toLowerCase());
        if(this.filters.transfer_id) passTransferId = manifest.transfer_id && manifest.transfer_id.toLowerCase().includes(this.filters.transfer_id.toLowerCase());
        if(this.filters.from_license_name) passFromLicenseName = manifest.from_license_name && manifest.from_license_name.toLowerCase().includes(this.filters.from_license_name.toLowerCase());
        pass = passLicense && passTransferId && passFromLicenseName;
        return pass;
      })
    },
    dateCounts(){
      if(this.loading || !this.manifests) return [];
      if(this.manifests && this.manifests.length === 0) return;
      const countObj = { };
      this.manifests.forEach((manifest) => {
        const date = this.$moment(manifest.transferred_at).format('YYYY-MM-DD');
        if(!countObj[date]) countObj[date] = 0;
        countObj[date]+= manifest.inventory_transfer_items.length;
      })
      // convert countObj to array
      const countArray = Object.keys(countObj).map((key) => {
        return {
          date: key,
          count: countObj[key]
        }
      })
      countArray.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      })
      return countArray;
    },
    legalTypeCounts(){
      if(this.loading || !this.manifests) return [];
      if(this.manifests && this.manifests.length === 0) return;
      const countObj = { };
      let total = 0;
      this.manifests.forEach((manifest) => {
        manifest.inventory_transfer_items.forEach((item) => {
          if(!countObj[item.inventory_type]) countObj[item.inventory_type] = 0;
          countObj[item.inventory_type]++;
          total++;
        })
      })
      // convert countObj to alphabetical order array
      const countArray = Object.keys(countObj).map((key) => {
        return {
          type: key,
          count: countObj[key]
        }
      })
      countArray.sort((a, b) => {
        return a.type.localeCompare(b.type);
      })
      countArray.unshift({
        type: 'Total Samples',
        count: total
      });
      return countArray;
    }
  },
  mounted() {
    this.loadStandard().then(() => {
      this.startFirestoreListener();
    });
  },
  methods: {
    async loadStandard(){
      // clear all customers, names, sampleNoteTypes, units
      this.loading = true;
      this.$store.$db().model('customers').deleteAll();
      this.$store.$db().model('names').deleteAll();
      this.$store.$db().model('sampleNoteTypes').deleteAll();
      this.$store.$db().model('units').deleteAll();
      this.$store.$db().model('sampleFlagTypes').deleteAll();
      this.$store.$db().model('sampleTypes').deleteAll();
      this.$store.$db().model('sampleCertTypes').deleteAll();
      this.$store.$db().model('sampleTestTypes').deleteAll();
      // await this.$store.dispatch('entities/deleteAll')
      await Promise.all([
        this.$store.$db().model('customers').api().fetch({with: 'primaryName'}),
        this.$store.$db().model('names').api().fetch(),
        this.$store.$db().model('sampleNoteTypes').api().fetch(),
        this.$store.$db().model('units').api().fetch(),
        this.$store.$db().model('customers').dispatch('getCustomers'),
        this.$store.$db().model('sampleFlagTypes').api().fetch(),
        this.$store.$db().model('sampleTypes').api().fetch(),
        this.$store.$db().model('sampleCertTypes').api().fetch(),
        this.$store.$db().model('sampleTestTypes').api().fetch(),
        this.$firestore.collection('Configs').doc('Belit').get().then(doc => {
          if (doc.exists) {
            const data = doc.data();
            this.$store.commit('setManifestFilteredFlags', data.manifest_filtered_flags || data.filtered_flags || []);
            this.$store.commit('setFilteredTestTypes', data.filtered_test_types || []);
          }
        }),
      ])
      this.loading = false;
    },
    async deleteManifest(transfer_id){
      await this.$firestore.collection('wcia_manifests').doc(transfer_id).delete();
    },
    async startFirestoreListener() {
      if(this.listener) this.listener();
      this.listener = this.$firestore.collection('wcia_manifests').orderBy('transferred_at', 'asc').onSnapshot((snapshot) => {
        // check for created, modified, or deleted
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            this.manifests.push(change.doc.data());
          }
          if (change.type === "modified") {
            const findManifest = this.manifests.find((manifest) => manifest.transfer_id === change.doc.data().transfer_id);
            if (findManifest) {
              Object.assign(findManifest, change.doc.data());
            }else{
              this.manifests.push(change.doc.data());
            }
          }
          if (change.type === "removed") {
            // remove from array
            this.manifests = this.manifests.filter((manifest) => manifest.transfer_id !== change.doc.data().transfer_id);
          }
        })
      })
    },
    sortTransferredAt(){
      this.manifests.sort((a, b) => {
        return new Date(b.transferred_at) - new Date(a.transferred_at);
      });
    },
    createOrder(manifest){
      this.loaded_manifest = manifest;
      this.$refs.create_order.show = true;
    }
  },
  beforeDestroy(){
    if(this.listener) this.listener();
    this.$store.$db().model('customers').deleteAll();
    this.$store.$db().model('names').deleteAll();
    this.$store.$db().model('sampleNoteTypes').deleteAll();
    this.$store.$db().model('units').deleteAll();
    this.$store.$db().model('sampleFlagTypes').deleteAll();
    this.$store.$db().model('sampleTypes').deleteAll();
    this.$store.$db().model('sampleCertTypes').deleteAll();
    this.$store.$db().model('sampleTestTypes').deleteAll();
  }
}
</script>

<style scoped>

</style>
